import { mapKeys, mapValues, snakeCase } from "lodash";

export function snakeCaseKeys(object: object) {
  return mapKeys(object, (v, k) => snakeCase(k));
}

// avoid using this with API calls as Rails will not deep camelCase when returning data
export function snakeCaseKeysDeep(object: object): object {
  const topLevel = snakeCaseKeys(object);
  return mapValues(topLevel, (value: any) => {
    if (typeof value === "object" && value !== null) {
      return snakeCaseKeysDeep(value);
    }
    return value;
  });
}



// WEBPACK FOOTER //
// ./app/javascript/utils/strings.ts